import { render, staticRenderFns } from "./form_list.vue?vue&type=template&id=af1082f2&"
import script from "./form_list.vue?vue&type=script&lang=js&"
export * from "./form_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports